import { useEffect } from 'react';
import { capabilities } from '../../../../capabilities';
import { useCapability } from '../../useCapability';
import { useNavComponentsManager } from '../../useNavComponentsManager';
function getTargets(self, mapTagToName, maybeTag, maybeName) {
  if (!maybeTag) {
    return maybeName ? [maybeName] : [self];
  }
  const targetsByTag = mapTagToName[maybeTag];
  // Exclude self
  return targetsByTag.filter(name => name !== self);
}
export const useVisibilityCapabilities = () => {
  const {
    setComponentState,
    componentNamesByTag
  } = useNavComponentsManager();
  const {
    subscribe: onShowComponent
  } = useCapability(capabilities.SHOW_COMPONENT_CAP.getName());
  const {
    subscribe: onHideComponent
  } = useCapability(capabilities.HIDE_COMPONENT_CAP.getName());
  useEffect(() => {
    const unsubscribeShow = onShowComponent(({
      byTag,
      byName
    } = {}, {
      source
    }) => {
      const targets = getTargets(source, componentNamesByTag, byTag, byName);
      targets.forEach(target => {
        setComponentState(target, currentState => Object.assign({}, currentState, {
          isOpen: true,
          isLoaded: true
        }));
      });
    });
    const unsubscribeHide = onHideComponent(({
      byTag,
      byName
    } = {}, {
      source
    }) => {
      const targets = getTargets(source, componentNamesByTag, byTag, byName);
      targets.forEach(target => setComponentState(target, currentState => Object.assign({}, currentState, {
        isOpen: false
      })));
    });
    return () => {
      unsubscribeShow();
      unsubscribeHide();
    };
  }, [onHideComponent, onShowComponent, setComponentState, componentNamesByTag]);
};